import { Row } from "@narmi/design_system";
import styles from "./style.module.css";

interface Props {
  title: string;
  text: string;
  detail?: string;
}
export function ErrorPage({ title, text, detail }: Props) {
  return (
    <div className={styles.ErrorContainer}>
      <div>
        <Row alignItems="center" justifyContent="center" gapSize="xs">
          <Row.Item shrink>
            <i className={`${"narmi-icon-alert-triangle"} ${styles.ErrorIcon}`} />
          </Row.Item>
          <Row.Item shrink>
            <p className="fontSize--heading3 fontWeight--semibold">{title}</p>
          </Row.Item>
        </Row>
        <p className="margin--top--s">{text}</p>
      </div>
      {detail && <div className="margin--top--xl">{detail}</div>}
    </div>
  );
}
